import React from "react";
import PropTypes from "prop-types";
import {
  INFO_DOCUMENT_GROUPS,
  documentDestination,
  isPdf,
} from "./infoDocuments";
import "./infoMenu.css";

/**
 * The company and legal documents, grouped, each with what it is and where it
 * goes. Shared by the info dialog and the /std/info page. Every document opens
 * in a new tab; one without an address is left out rather than shown dead.
 */
const InfoDocumentList = ({ links, t }) => (
  <div className="info-docs">
    {INFO_DOCUMENT_GROUPS.map((group) => {
      const documents = group.documents.filter((doc) => links?.[doc.id]);
      if (documents.length === 0) return null;
      const headingId = `info-docs-${group.id}`;

      return (
        <section key={group.id} aria-labelledby={headingId}>
          <h4 id={headingId} className="info-docs-group">
            {t(`infoPage.${group.id}`)}
          </h4>
          <ul className="info-docs-list">
            {documents.map((doc) => {
              const href = links[doc.id];
              return (
                <li key={doc.id}>
                  <a
                    className="info-doc"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="info-doc-tile" aria-hidden="true">
                      <i className={`fas ${doc.icon}`} />
                    </span>
                    <span className="info-doc-text">
                      <span className="info-doc-title">
                        {t(`infoPage.${doc.id}`)}
                        {isPdf(href) && (
                          <span className="info-doc-chip">PDF</span>
                        )}
                      </span>
                      <span className="info-doc-desc">
                        {t(`infoPage.${doc.id}Description`)}
                      </span>
                    </span>
                    <span className="info-doc-dest">
                      <span className="info-doc-host">
                        {documentDestination(href)}
                      </span>
                      <i
                        className="fas fa-arrow-up-right-from-square info-doc-go"
                        aria-hidden="true"
                      />
                      <span className="sr-only">
                        ({t("infoPage.opensInNewTab")})
                      </span>
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </section>
      );
    })}
  </div>
);

InfoDocumentList.propTypes = {
  links: PropTypes.objectOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
};

export default InfoDocumentList;
